/**
 * useTaskActivity — real-time subscription to a task's activity / comment
 * timeline (todos/{taskId}/activity). Returns [] when taskId is null.
 */

import { useState, useEffect } from 'react';
import { subscribeActivity } from '@/services/todo.service';
import type { TaskActivity } from '@/types/schema';

interface UseTaskActivityReturn {
  entries: TaskActivity[];
  loading: boolean;
}

export function useTaskActivity(taskId: string | null): UseTaskActivityReturn {
  const [entries, setEntries] = useState<TaskActivity[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!taskId) {
      setEntries([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const unsubscribe = subscribeActivity(taskId, (e) => {
      setEntries(e);
      setLoading(false);
    });
    return unsubscribe;
  }, [taskId]);

  return { entries, loading };
}
